import { render } from "./Stage.vue?vue&type=template&id=9cdeba48"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"

import "./Stage.vue?vue&type=style&index=0&id=9cdeba48&lang=css"
script.render = render

export default script